// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../k8-opt-exec-ST-13d3ddad9198/bin/redo/bigcommerce-storefront/webpack.bin.runfiles/npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../k8-opt-exec-ST-13d3ddad9198/bin/redo/bigcommerce-storefront/webpack.bin.runfiles/npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._m-0 {\n  display: flex;\n}\n\n._m-1 {\n  flex-direction: row;\n}\n\n._m-1._m-2 {\n    flex-direction: row-reverse;\n  }\n._m-3 {\n  flex-direction: column;\n}\n._m-3._m-2 {\n    flex-direction: column-reverse;\n  }\n\n._m-4 {\n  align-items: center;\n}\n._m-5 {\n  align-items: flex-start;\n}\n._m-6 {\n  align-items: flex-end;\n}\n._m-7 {\n  align-items: stretch;\n}\n._m-8 {\n  align-items: baseline;\n}\n\n._m-9 {\n  align-self: center;\n}\n._m-a {\n  align-self: flex-start;\n}\n._m-b {\n  align-self: flex-end;\n}\n._m-c {\n  align-self: stretch;\n}\n._m-d {\n  align-self: baseline;\n}\n\n._m-e {\n  justify-content: center;\n}\n._m-f {\n  justify-content: flex-start;\n}\n._m-g {\n  justify-content: flex-end;\n}\n._m-h {\n  justify-content: space-between;\n}\n._m-i {\n  justify-content: space-around;\n}\n._m-j {\n  justify-content: space-evenly;\n}\n\n._m-k {\n  flex-wrap: wrap;\n}\n\n._m-l {\n  flex-wrap: nowrap;\n}\n\n._m-m {\n  flex-wrap: wrap-reverse;\n}\n", ""]);
// Exports
export var flex = "_m-0";
export var row = "_m-1";
export var reverse = "_m-2";
export var column = "_m-3";
export var alignCenter = "_m-4";
export var alignFlexStart = "_m-5";
export var alignFlexEnd = "_m-6";
export var alignStretch = "_m-7";
export var alignBaseline = "_m-8";
export var alignSelfCenter = "_m-9";
export var alignSelfFlexStart = "_m-a";
export var alignSelfFlexEnd = "_m-b";
export var alignSelfStretch = "_m-c";
export var alignSelfBaseline = "_m-d";
export var justifyCenter = "_m-e";
export var justifyFlexStart = "_m-f";
export var justifyFlexEnd = "_m-g";
export var justifySpaceBetween = "_m-h";
export var justifySpaceAround = "_m-i";
export var justifySpaceEvenly = "_m-j";
export var wrapWrap = "_m-k";
export var wrapNowrap = "_m-l";
export var wrapWrapReverse = "_m-m";
export default ___CSS_LOADER_EXPORT___;
